import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface AdminOnlyProps {
  children: ReactNode;
}

const AdminOnly = ({ children }: AdminOnlyProps) => {
  const { isAuthenticated, isAdmin, loading, profileLoading } = useAuth();
  const location = useLocation();

  if (loading || profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Verificando acesso...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    return <Navigate to="/login" replace state={{ error: "Acesso negado" }} />;
  }

  return <>{children}</>;
};

export default AdminOnly;


